// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1Xap6","info":"UpdateTermsInfo_info__4ligO"};